// operatoriThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setOperatori,
  addOperatori,
  addOperatoriId,
  updateOperatori,
  deleteOperatori,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
} from "./operatoriSlice.js";
import operatoriAPI from "../../services/operatoriAPI.js";
import { toast } from "react-toastify";

export const fetchOperatori = createAsyncThunk(
  "operatoriData/fetchOperatori",
  async (_, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      const response = await operatoriAPI.getAllOperatori();
      
      // Check store before setting
      const storeBefore = getState().operatori;
      
      dispatch(setOperatori(response.data.data));
      
      // Check store after setting
      const storeAfter = getState().operatori;
      
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch operatori.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const singleOperatori = createAsyncThunk(
  "operatori/fetchSingleOperatori",
  async (operatoriId, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await operatoriAPI.getSingleOperatori(operatoriId);
      dispatch(addOperatoriId([response.data.data]));
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch single operatore.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const createOperatori = createAsyncThunk(
  "operatoriData/createOperatori",
  async (payload, { dispatch, getState }) => {
    dispatch(apiRequestStart());
    try {
      const response = await operatoriAPI.createOperatori(payload);
      toast.success(response?.data?.message)
      // Dispatch the action
      dispatch(addOperatori(response.data.data));
      
      // Log the state after the action
      const storeAfterAdd = getState().operatori;
      
      dispatch(apiRequestSuccess());

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to create operatore.";
        toast.error(error.response?.data?.errors.error || "Failed to create operatore.")
      // dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);
export const updateOperatoriData = createAsyncThunk(
  "operatoriData/updateOperatori",
  async ({ id, data }, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response = await operatoriAPI.updateOperatori(id, data);
      dispatch(updateOperatori(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to update operatore.";
        toast.error(error.response?.data?.errors.error || "Failed to create operatore.")
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);

export const deleteOperatoriData = createAsyncThunk(
  "operatoriData/deleteOperatori",
  async (id, { dispatch }) => {
    dispatch(apiRequestStart());
    try {
      const response=  await operatoriAPI.deleteOperatori(id);
      dispatch(deleteOperatori(id));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return id;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete operatore.";
      dispatch(apiRequestFailure(errorMessage));
      throw new Error(errorMessage);
    }
  }
);